import { Space, Tag, Typography } from 'antd';
import type { AppFeedbackReviewStatus, AppFeedbackSystemReleaseReason } from 'breuer-supercharged-sdk';
import { SystemReleaseTag } from '@/pages/feedback-review/system_release_tag';
import { feedbackDeliveryStatus } from './app_feedback_utils';

const { Text } = Typography;

interface AppFeedbackDeliveryStatusProps {
    reviewStatus: AppFeedbackReviewStatus | null | undefined;
    emailSentAt: string | null | undefined;
    systemReleaseReason: AppFeedbackSystemReleaseReason | null | undefined;
}

/** Mail-Status ans Support-Postfach; offene/verworfene Meldungen als neutrales Tag statt rotem „nicht versendet“. */
export function AppFeedbackDeliveryStatus({ reviewStatus, emailSentAt, systemReleaseReason }: AppFeedbackDeliveryStatusProps) {
    const status = feedbackDeliveryStatus({ reviewStatus, emailSentAt });
    return (
        <Space size={6} wrap>
            {status.kind === 'in_review' || status.kind === 'discarded' ? (
                <Tag style={{ marginInlineEnd: 0 }}>{status.text}</Tag>
            ) : (
                <Text type={status.kind === 'sent' ? 'success' : 'danger'}>{status.text}</Text>
            )}
            <SystemReleaseTag reason={systemReleaseReason} />
        </Space>
    );
}
